module.exports = __webpack_public_path__ + "img/nitron.5cb7adf4.jpg";